import { IsEmail, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { IBaseResponse } from './base-response.dto';

export interface IDevUser {
  _id?: string;
  email: string;
  firstName: string;
  lastName: string;
  username: string;
  company?: string;
  teams?: any[];
  createdAt?: Date;
}

export interface IDevUserTokenPayload extends IDevUser {
  uid?: string;
  iat?: number;
  exp?: number;
}

export interface DevUserTokenResponse {
  token: string;
}

export interface DevUserAuthRequest {
  username: string;
  password: string;
  name?: string;
}

/* -------------------------------------------------------------------------- */
/*                               Create new User                              */
/* -------------------------------------------------------------------------- */

export class CreateDevUserDto {
  @IsNotEmpty()
  firstName: string;

  @IsNotEmpty()
  lastName: string;

  @IsNotEmpty()
  username: string;

  @IsNotEmpty()
  @IsEmail()
  email: string;

  @IsOptional()
  @IsString()
  company: string;

  @IsOptional()
  teams: any[];

  @IsNotEmpty()
  password: string;
}

export interface CreateDevUserResponse extends IBaseResponse {
  id: string;
}
